import { Badge, type BadgeProps } from '@/components/base/badge'
import type { TestExecutionSyncState } from '@/gql/graphql'

const states: { [state: string]: { color: BadgeProps['color'], name: string } } = {
  pending: {
    color: 'amber',
    name: 'Pending',
  },
  processing: {
    color: 'blue',
    name: 'Processing',
  },
  succeeded: {
    color: 'green',
    name: 'Succeeded',
  },
  failed: {
    color: 'red',
    name: 'Failed',
  },
}

interface Props {
  state: TestExecutionSyncState
}

export const StateBadge = ({ state }: Props) => {
  return <Badge color={ states[state].color }>{ states[state].name }</Badge>
}
